<app-time
  [userId]="userId"
  [interval]="INTERVAL"
  [timeFormControlParams]="timeFormControlParams"
  (formValuesChanged)="onFormValuesChanged($event)"
></app-time>
